import administratorService from '@/api/administrators'
import { ADMINISTRATOR } from '../types'

export default {
  namespaced: true,
  state: {
    administrators: [],
    userEmail: '',
  },
  mutations: {
    [ADMINISTRATOR.SET_ADMINISTRATORS] (state, administrators) {
      state.administrators = administrators
    },
  },
  actions: {
    async getAdministrators ({commit}) {
        await administratorService.getAdministrators().then((response) => {
          commit(ADMINISTRATOR.SET_ADMINISTRATORS, response.data)
        })
      },
    // eslint-disable-next-line no-empty-pattern
    async saveAdministrator ({}, administrator) {
      const permissions = administrator.permissions
      const email = administrator.email
      const sites = administrator.sites
      const body = {
        permissions,
        email,
        sites
      }
      await administratorService.saveAdministrator(body)
    },
    // eslint-disable-next-line no-empty-pattern
    async editAdministrator ({}, administrator) {
      const permissions = administrator.permissions
      const email = administrator.email
      const sites = administrator.sites
      const body = {
        permissions,
        email,
        sites
      }
      await administratorService.editAdministrator(body)
    },
    // eslint-disable-next-line no-empty-pattern
    async removeAdministrator ({}, email) {
      await administratorService.removeAdministrator(email)
    },
  },
}
